module.exports = __webpack_public_path__ + "static/maxibear-a9decff7475faa09a58733dd2758f23d.svg";